module.exports = __webpack_public_path__ + "img/front-left.af267170.svg";